var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectDetectionEventIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.04167,
    y: 1.04167,
    width: 22.9167,
    height: 22.9167,
    rx: 4.51389,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.04167,
    y: 1.04167,
    width: 22.9167,
    height: 22.9167,
    rx: 4.51389,
    stroke: "#FF8027",
    strokeWidth: 2.08333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3365 11.218L17.6611 9.84199L13.8802 6.79415L12.5814 8.18304L11.2568 6.76843L7.4502 9.84199L8.77478 11.218L7.4502 12.594L8.89052 13.7579V15.404L12.5685 18.3425L16.2401 15.404V13.7386L17.6611 12.6005L16.3365 11.218ZM12.5556 13.3592L9.88075 11.218L12.5556 9.08325L15.2563 11.218L12.5556 13.3592ZM15.7707 11.6938L16.5744 12.5297L13.9703 14.6645L13.1344 13.8222L15.7707 11.6938ZM13.9703 7.77795L16.6194 9.90629L15.79 10.7551L13.1344 8.62028L13.9703 7.77795ZM11.1989 7.7458L12.0412 8.59456L9.32134 10.7551L8.51758 9.90629L11.1989 7.7458ZM9.32134 11.6938L12.0412 13.8415L11.1925 14.6902L8.51758 12.5297L9.32134 11.6938ZM9.61712 14.343L11.2568 15.6676L12.2213 14.6645V17.1401L9.64927 15.0568L9.61712 14.343ZM15.5199 15.0568L12.9479 17.1144V14.6645L13.8867 15.6419L15.5263 14.3559V15.0889L15.5199 15.0568Z",
    fill: "#FF8027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectDetectionEventIcon);
export default __webpack_public_path__ + "static/media/Object-detection-Event-Icon.8eb97b55ba92516979aa85130639b0ff.svg";
export { ForwardRef as ReactComponent };